export type AvailabilityState = 'yes' | 'no' | 'limited';

export type ComparisonCellValue =
  | { readonly kind: 'price'; readonly amount: string }
  | { readonly kind: 'text'; readonly text: string }
  | { readonly kind: 'availability'; readonly state: AvailabilityState };

export type ComparisonRow = {
  readonly label: string;
  readonly values: Readonly<Record<string, ComparisonCellValue>>;
};

export const AVAILABILITY_LABELS: Readonly<Record<AvailabilityState, string>> = {
  yes: 'Yes',
  no: 'No',
  limited: 'Limited',
};
